import React from "react";
import PropTypes from "prop-types";
import { dateFormatter } from "../../../../../../utils/commonUtil";
import { UnderlyingContent } from "../../style";
import { ScheduleLabel, CustomSectionLabel } from "./style";

const getPendingText = ({
  schedule,
  history,
  grantActivityClick,
  grantDetailsHandler,
}) => {
  switch (schedule.length) {
    case 1:
      return (
        <CustomSectionLabel>
          {`You have ${schedule.length} ${
            history ? "" : "active"
          } grant schedule `}
          <UnderlyingContent
            id="anrgrantDetails"
            onClick={() => grantDetailsHandler(schedule[0].scheduleId)}
          >{`(Schedule ID: ${schedule[0].scheduleId})`}</UnderlyingContent>
          {` with ${
            schedule[0].pendingSpawn
          } pending payment(s) until ${dateFormatter(
            schedule[0].scheduleEndDate
          )}`}
        </CustomSectionLabel>
      );
    case 0:
      return (
        <CustomSectionLabel>
          {`You have no ${history ? "" : "active"} grant schedule.`}
        </CustomSectionLabel>
      );
    default:
      return (
        <CustomSectionLabel>
          {`You have ${schedule.length} ${
            history ? "" : "active"
          } grant schedule. `}
          <UnderlyingContent
            id="anrViewGrantActivitySchedule"
            onClick={grantActivityClick}
          >
            View Grant Activity
          </UnderlyingContent>
        </CustomSectionLabel>
      );
  }
};

export default function ScheduleSection({
  schedule,
  history,
  grantActivityClick,
  grantDetailsHandler,
}) {
  const sectionTitle = history ? "Schedule" : "Active Schedule";
  return (
    <>
      <ScheduleLabel>{sectionTitle}</ScheduleLabel>
      {getPendingText({
        schedule,
        history,
        grantActivityClick,
        grantDetailsHandler,
      })}
    </>
  );
}

ScheduleSection.propTypes = {
  schedule: PropTypes.arrayOf(
    PropTypes.shape({
      scheduleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      pendingSpawn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      scheduleEndDate: PropTypes.string,
    })
  ),
  history: PropTypes.any,
  grantActivityClick: PropTypes.func,
  grantDetailsHandler: PropTypes.func,
};
